import BaseService from './baseService';

class ProductInterfaces extends BaseService {
	async getProductInterfaces(opts = {}) {
    this.endPoint = '/product-interfaces';
		return this.get(opts);
  }
  async createProductInterface(payload){
    this.endPoint = '/product-interfaces';
    return await this.post(payload); 
  }
  async updateProductInterface(id,payload,opts={}){
    this.endPoint = '/product-interfaces';
    return await this.putOne(id,payload,opts);
  }
  async deleteProductInterface(id,opts={}){
    this.endPoint = '/product-interfaces';
    return await this.delete(id,opts);
  }
}

export default new ProductInterfaces();